import { XcoreConfigRawValue, XcoreConfigValue, XcoreEnvValueUnion } from ".";
import { ConfigError } from "./errors";
import { resolveApiUrl } from "./utils";
import { validateConfig } from "./validate";

/**
 * Main entry for xcore config json.
 *
 * @throws {ConfigError}
 */
export const prepareEnvironmentConfig = (
  { env: envConfig, defaultLocale, admin }: XcoreConfigRawValue,
  skipConfigValidation?: boolean
): XcoreConfigValue => {
  if (!envConfig) {
    throw new ConfigError("Invalid config: missing environments config");
  }

  const env = process.env.XCORE_ENV as XcoreEnvValueUnion | undefined;

  if (!env) {
    throw new ConfigError("Missing XCORE_ENV");
  }

  if (!(env in envConfig)) {
    throw new ConfigError("Invalid config: defined XCORE_ENV does not exist in config file");
  }

  const envValue: XcoreConfigValue = {
    env,
    ...envConfig[env],
    defaultLocale,
    apiUrl: resolveApiUrl(),
    admin: {
      // Common admin config
      ...admin,
      // Env specific admin config
      ...envConfig[env].admin,
    },
  };

  !skipConfigValidation && validateConfig(envValue);

  return envValue as XcoreConfigValue;
};
